import localforage from "localforage";
import type { DBProduct } from "@commons-monorepo/index";

export const localDBConfig = {
  name: "local-sumer-cart",
  version: 1,
  storeName: "cart",
  description: "Cart storage",
};

export const sessionShoppingCarts = "sumer-shopping-carts";

localforage.config(localDBConfig);

export const getCartSession = (
  cartId: string | undefined,
): Promise<DBProduct[] | null> => {
  return cartId ? localforage.getItem(cartId) : Promise.resolve(null);
};

export const saveCartSession = (
  cartId: string,
  products: DBProduct[],
): Promise<DBProduct[]> => {
  return localforage.setItem(cartId, products);
};

const localDBShoppingCartIds = localforage.createInstance({
  ...localDBConfig,
  storeName: "shopping-cart-ids",
  description: "Shopping cart ids",
});

export const getShoppingCart = (ownerId: string): Promise<string | null> => {
  return localDBShoppingCartIds.getItem(ownerId);
};

export const saveShoppingCart = (
  ownerId: string,
  shoppingCartId: string,
): Promise<string> => {
  return localDBShoppingCartIds.setItem(ownerId, shoppingCartId);
};

const getSessionShoppingCarts = () => {
  const shoppingCartsSaved =
    sessionStorage.getItem(sessionShoppingCarts) || "{}";
  try {
    return JSON.parse(shoppingCartsSaved) as {
      [key: string]: string | undefined;
    };
  } catch (error) {
    return {};
  }
};

export const getSessionShoppingCart = (ownerId: string): string | undefined => {
  const shoppingCartsSaved = getSessionShoppingCarts();
  return shoppingCartsSaved[ownerId];
};

export const saveSessionShoppingCart = (
  ownerId: string,
  shoppingCartId: string | undefined,
) => {
  const shoppingCartsSaved = getSessionShoppingCarts();
  shoppingCartsSaved[ownerId] = shoppingCartId;
  sessionStorage.setItem(
    sessionShoppingCarts,
    JSON.stringify(shoppingCartsSaved),
  );
};
